import { render, staticRenderFns } from "./SeguroPrestamista.vue?vue&type=template&id=89f77914"
import script from "./SeguroPrestamista.vue?vue&type=script&lang=js"
export * from "./SeguroPrestamista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports